import {
    collection, addDoc, query, where, orderBy, onSnapshot, deleteDoc, doc, serverTimestamp, updateDoc
} from 'firebase/firestore';
import { db } from './firebase';
import { getUserWorkspace } from './firestore';

let _wsId = null;
export const setSolicitudesWorkspace = async (userId) => {
    if (!userId) return;
    _wsId = await getUserWorkspace(userId);
    return _wsId;
};
const withWs = (data) => ({ ...data, workspaceId: _wsId || 'default' });
const wsWhere = () => _wsId ? where('workspaceId', '==', _wsId) : null;

// Tipos de solicitud:
// - 'vacaciones'   { dateFrom, dateTo, daysCount, reason }
// - 'olvido'       { date, missingMark ('entry'|'exit'), proposedTime, reason }
// - 'permiso'      { date, hourFrom, hourTo, reason }
// - 'home_office'  { date, reason }

export const createSolicitud = async (data) => {
    const ref = collection(db, 'solicitudes');
    return await addDoc(ref, withWs({
        ...data,
        status: 'pendiente',
        createdAt: serverTimestamp(),
    }));
};

export const subscribeToMySolicitudes = (userId, callback) => {
    if (!userId) return () => {};
    const ref = collection(db, 'solicitudes');
    const ws = wsWhere();
    const constraints = [where('userId', '==', userId)];
    if (ws) constraints.push(ws);
    const q = query(ref, ...constraints);
    return onSnapshot(q, (snapshot) => {
        const list = [];
        snapshot.forEach((d) => list.push({ id: d.id, ...d.data() }));
        list.sort((a, b) => {
            const ta = a.createdAt?.toMillis?.() || 0;
            const tb = b.createdAt?.toMillis?.() || 0;
            return tb - ta;
        });
        callback(list);
    });
};

export const subscribeToAllSolicitudes = (callback) => {
    const ref = collection(db, 'solicitudes');
    const ws = wsWhere();
    const q = ws ? query(ref, ws) : query(ref);
    return onSnapshot(q, (snapshot) => {
        const list = [];
        snapshot.forEach((d) => list.push({ id: d.id, ...d.data() }));
        list.sort((a, b) => {
            const ta = a.createdAt?.toMillis?.() || 0;
            const tb = b.createdAt?.toMillis?.() || 0;
            return tb - ta;
        });
        callback(list);
    });
};

export const approveSolicitud = async (id, reviewerId) => {
    const ref = doc(db, 'solicitudes', id);
    await updateDoc(ref, {
        status: 'aprobada',
        reviewedAt: serverTimestamp(),
        reviewedBy: reviewerId,
    });
};

export const rejectSolicitud = async (id, reviewerId, reason) => {
    const ref = doc(db, 'solicitudes', id);
    await updateDoc(ref, {
        status: 'rechazada',
        reviewedAt: serverTimestamp(),
        reviewedBy: reviewerId,
        rejectionReason: reason || null,
    });
};

export const cancelSolicitud = async (id) => {
    const ref = doc(db, 'solicitudes', id);
    await deleteDoc(ref);
};
